
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketplace/about",
      function () {
        return require("private-next-pages/marketplace/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketplace/about"])
      });
    }
  